module.exports = __webpack_public_path__ + "static/media/price.fb97e4c8.svg";